import AppLayout from './app/AppLayout.vue'
// import AppWrapper from './app/AppWrapper.vue'
import AuthLayout from './auth/AuthLayout.vue'
import DefaultLayout from './default/DefaultLayout.vue'
import Wrapper from './default/Wrapper.vue'

const layouts = {
  auth: AuthLayout,
  app: AppLayout,
  default: DefaultLayout,
}
const wrappers = {
  auth: Wrapper,
  app: Wrapper,
  default: 'Wrapper',
}

function resolveLayouts(route) {
  const layoutName = route?.meta?.layoutName || 'default'
  const wrapperName = route?.meta?.wrapperName || layoutName
  const layout = layouts[layoutName] || layouts.default
  const wrapper = wrappers[wrapperName] || wrappers.default
  return { wrapper, layout, layoutName, wrapperName }
}

export default resolveLayouts
